import { CustomerConfInterface } from '../interfaces/customerConf.interface';

export const defaultTypography = 'https://fonts.googleapis.com/css?family=Poppins:300,400,500,600&display=swap';

export const euroinnovaConf: CustomerConfInterface = {
  themeName: 'euroinnova',
  appName: 'Euroinnova',
  appIcon: 'assets/euroinnova/euroinnova.ico'
};

export const inesaludConf: CustomerConfInterface = {
  themeName: 'inesalud',
  appName: 'Inesalud',
  appIcon: 'assets/inesalud/inesalud.ico',
  typographyFamilyLink: 'https://fonts.googleapis.com/css?family=Comfortaa'
};

export const inesemConf: CustomerConfInterface = {
  themeName: 'inesem',
  appName: 'Inesem',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const educaConf: CustomerConfInterface = {
  themeName: 'educa',
  appName: 'Educa',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const edusportConf: CustomerConfInterface = {
  themeName: 'edusport',
  appName: 'Edusport',
  appIcon: 'assets/inesalud/inesalud.ico',
  typographyFamilyLink: 'https://fonts.googleapis.com/css?family=Manrope'
};

export const enaldeConf: CustomerConfInterface = {
  themeName: 'enalde',
  appName: 'Enalde',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const esibeConf: CustomerConfInterface = {
  themeName: 'esibe',
  appName: 'Esibe',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const ineafConf: CustomerConfInterface = {
  themeName: 'ineaf',
  appName: 'Ineaf',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const innovaConf: CustomerConfInterface = {
  themeName: 'innova',
  appName: 'Innova',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const rededucaConf: CustomerConfInterface = {
  themeName: 'rededuca',
  appName: 'Red Educa',
  appIcon: 'assets/inesalud/inesalud.ico'
};

export const educaopenaiConf: CustomerConfInterface = {
  themeName: 'educaopenai',
  appName: 'Educa Open AI',
  appIcon: 'assets/educaopenai/openai.ico',
  typographyFamilyLink: 'https://fonts.googleapis.com/css?family=Space Grotesk'
};

export const universityConf: CustomerConfInterface = {
  themeName: 'university',
  appName: 'Educa University',
  appIcon: 'assets/university/university.ico',
  typographyFamilyLink: 'https://fonts.googleapis.com/css?family=Rubik'
};
